import { getNotifications } from '../../lib/services/mobivers/api';
import { DispatchApiNotification } from '../../types/redux';

export const NOTHING_TO_NOTIFY = 'NOTHING_TO_NOTIFY';
export const FETCH_NOTIFICATION_MESSAGE = 'FETCH_NOTIFICATION_MESSAGE';

export function fetchNotification(): (
	dispatch: DispatchApiNotification
) => void {
	return async (dispatch: DispatchApiNotification) => {
		try {
			const data = await getNotifications();
			dispatch({ type: NOTHING_TO_NOTIFY, payload: data });
		} catch (error) {
			dispatch({
				type: FETCH_NOTIFICATION_MESSAGE,
				payload: error,
			});

			return error;
		}
	};
}

export function markAsRead(): { type: string; payload: any } {
	return {
		type: NOTHING_TO_NOTIFY,
		payload: {},
	};
}
